import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  computed: {
    ...mapStores(usePrintStoreStore)
  },
  methods: {
    toPrintStore() {
      const targetRoute = this.printStoreStore.routeBeforeCheckout

      if (targetRoute) {
        this.$router.push({
          name: targetRoute.name,
          params: targetRoute.params
        })
        this.printStoreStore.routeBeforeCheckout = undefined
        return
      }

      this.$router.push({ name: 'printStore' })
    }
  }
}
